import { Controller } from "@hotwired/stimulus"

// The header cart badge and the drawer dialog share one controller, so adding an item from
// anywhere on the page (a Turbo Stream response) can reopen it, same backdrop-click pattern
// as the product and newsletter dialogs.
export default class extends Controller {
  static targets = ["dialog"]

  open() {
    if (this.dialogTarget.open) return
    this.dialogTarget.showModal()
  }

  close() {
    this.dialogTarget.close()
  }

  backdrop(event) {
    if (event.target !== this.dialogTarget) return
    const rect = this.dialogTarget.getBoundingClientRect()
    const outside = event.clientX < rect.left || event.clientX > rect.right ||
                    event.clientY < rect.top || event.clientY > rect.bottom
    if (outside) this.close()
  }

  // Only an "add to cart" submission (marked with data-cart-action="add") reopens the
  // drawer - removing an item happens from inside the already-open drawer.
  onSubmitEnd(event) {
    if (event.target.dataset.cartAction === "add" && event.detail.success) this.open()
  }
}
